import React from "react";
import { Pagination as MantinePagination, Group } from "@mantine/core";
import styles from "./styles.module.css";
import Text from "@/components/atoms/Text";
import Select from "@/components/atoms/Select";

interface PaginationProps {
  totalItems: number;
  rowsPerPage: number;
  activePage: number;
  onRowsPerPageChange: (value: string | null) => void;
  onPageChange: (page: number) => void;
  testIdPrefix?: string;
}

const Pagination: React.FC<PaginationProps> = (props) => {
  const { totalItems, rowsPerPage, onRowsPerPageChange, onPageChange, activePage, testIdPrefix } = props;

  const totalPages = Math.ceil(totalItems / rowsPerPage);
  const startItem = (activePage - 1) * rowsPerPage + 1;
  const endItem = Math.min(activePage * rowsPerPage, totalItems);

  return (
    <Group justify="flex-end" mt="10">
      <Select
        className={styles.paginationSelect}
        label=""
        data={["15", "30", "50", "100"]}
        value={String(rowsPerPage)}
        onChange={onRowsPerPageChange}
        data-testid={testIdPrefix && `${testIdPrefix}-rows-per-page-select`}
      />

      <Text data-testid={testIdPrefix && `${testIdPrefix}-pagination-range`}>
        {totalItems > 0 ? startItem : 0}-{endItem} av {totalItems}
      </Text>
      <MantinePagination
        radius={0}
        total={totalPages}
        value={activePage}
        onChange={onPageChange}
        withPages={false}
        getControlProps={(control) => {
          if (!testIdPrefix) return {};
          if (control === "next") return { "data-testid": `${testIdPrefix}-pagination-next` };
          if (control === "previous") return { "data-testid": `${testIdPrefix}-pagination-previous` };
          return {};
        }}
      />
    </Group>
  );
};

export default Pagination;
